import { cn } from "@/lib/utils";

const colorFor = (grade) => {
    if (grade == null) return "bg-slate-100 text-slate-400 border border-slate-200";
    if (grade >= 5) return "bg-sage text-white";
    if (grade >= 4) return "bg-seablue text-white";
    if (grade >= 3) return "bg-sand text-slate-900";
    if (grade >= 2) return "bg-orange-400 text-white";
    return "bg-terracotta text-white";
};

export const GradeBadge = ({ grade, size = "md", testId }) => {
    const sizeCls = size === "lg" ? "w-16 h-16 text-3xl" : size === "sm" ? "w-8 h-8 text-sm" : "w-10 h-10 text-lg";
    return (
        <div
            className={cn(
                "rounded-full flex items-center justify-center font-bold font-heading shrink-0",
                sizeCls,
                colorFor(grade),
            )}
            data-testid={testId}
            data-grade={grade ?? "none"}
        >
            {grade == null ? "—" : grade}
        </div>
    );
};
